import store from '../store/store'
import { useCaseMap } from '../utils/useCase/useCaseMap'

export const UseCaseDirective = {
  inserted: function(el, binding, vnode) {
    var allowedUseCases = JSON.parse(store.getters['user/jwtData'].UserData)
      .AllowedUseCaseIds
    var useCases
    var hide = false

    if (Array.isArray(binding.value)) {
      useCases = binding.value.map(function(x) {
        if (useCaseMap[x] === undefined) {
          throw new TypeError(
            `Undefined key for Use Case (${x}). Please refer to UseCaseMap.js to find available keys.`
          )
        }
        return useCaseMap[x]
      })

      hide = !useCases.some(r => allowedUseCases.includes(r))
    } else {
      useCases = useCaseMap[binding.value]

      if (useCases === undefined) {
        throw new TypeError(
          `Undefined key for Use Case (${
            binding.value
          }). Please refer to UseCaseMap.js to find available keys.`
        )
      }

      //We're using None to specify that non-exsiting use-case on generic table - eg. we dont support user deletion - so we're going to set None for Create
      if (useCases == 'None') {
        hide = false
      } else {
        hide = !allowedUseCases.includes(useCases)
      }
    }

    if (hide) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
}
